import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-teacher-lesson-details-page',
    templateUrl: './teacher-lesson-details-page.component.html',
    styleUrls: ['./teacher-lesson-details-page.component.scss'],
    standalone: false
})
export class TeacherLessonDetailsPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
